import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ArrowUpIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M10.75 18.75V8.58l-4.308 4.308a1.25 1.25 0 1 1-1.768-1.768L12 3.793l7.326 7.327a1.25 1.25 0 1 1-1.768 1.768L13.25 8.58v10.17a1.25 1.25 0 0 1-2.5 0" />
    </Icon>
  );
}

ArrowUpIcon.displayName = 'ArrowUpIcon';
